import { Type } from 'main.core';
import getFileExtension from './get-file-extension';

const imageExtensions = ['jpg', 'bmp', 'jpeg', 'jpe', 'gif', 'png', 'webp'];

const isResizableImage = (file: File | string, mimeType: string = null) => {
	const filename = Type.isFile(file) ? file.name : file;
	const type = Type.isFile(file) ? file.type : mimeType;
	const extension = getFileExtension(filename).toLowerCase();

	if (imageExtensions.includes(extension))
	{

		if (type === null || /^image/.test(type))
		{
			return true;
		}
	}

	return false;
};

export default isResizableImage;
